import React from 'react';
import { motion } from 'framer-motion';
import { StaggerContainer, staggerChild } from './ScrollReveal';
import './Stats.css';

const stats = [
  {
    value: '13+ yrs',
    desc: 'of hands-on business operations & process expertise behind every build',
  },
  {
    value: 'End-to-end',
    desc: 'one team, from discovery through delivery — no handoffs between vendors',
  },
  {
    value: 'Built around you',
    desc: 'every solution personalized to your operating model, not a template',
  },
];

function Stats() {
  return (
    <section className="stats-band">
      <StaggerContainer className="wrap stats-grid" staggerDelay={0.15}>
        {stats.map((stat, i) => (
          <motion.div key={i} className="stat" variants={staggerChild}>
            <h4>{stat.value}</h4>
            <p>{stat.desc}</p>
          </motion.div>
        ))}
      </StaggerContainer>
    </section>
  );
}

export default Stats;
